var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressbar",attrs:{"data-layout":_vm.layout,"data-type":_vm.type,"data-status":_vm.status}},[_c('div',{ref:"bar",staticClass:"complete",style:({backgroundColor: _vm.color})})])}
var staticRenderFns = []

export { render, staticRenderFns }